"use client";

import clsx from "clsx";

import { Button } from "@/shared/ui/button/Button";

import styles from "./ErrorFallback.module.css";

type ErrorFallbackProps = {
  title?: string;
  message?: string;
  reset?: () => void;
  fullPage?: boolean;
};

export function ErrorFallback({
  title = "Что-то пошло не так",
  message = "Не удалось загрузить страницу. Попробуйте обновить её или зайти позже.",
  reset,
  fullPage = false,
}: ErrorFallbackProps) {
  return (
    <div
      className={clsx(styles.wrap, fullPage && styles.fullPage)}
      role="alert"
      aria-live="polite"
    >
      <h1 className={styles.title}>{title}</h1>
      <p className={styles.message}>{message}</p>
      <div className={styles.actions}>
        {reset && (
          <Button type="button" onClick={reset}>
            Попробовать снова
          </Button>
        )}
        <Button type="button" variant="outline" href="/">
          На главную
        </Button>
      </div>
    </div>
  );
}
